import { type StateCreator, create } from 'zustand';
import { devtools } from 'zustand/middleware';

/**
 * Type-safe store creator with devtools middleware
 * This wrapper ensures all stores have devtools enabled in development
 */
export const createStore = <T>(
  name: string,
  storeCreator: StateCreator<T, [['zustand/devtools', never]], [], T>,
) => {
  return create<T>()(
    devtools(storeCreator, {
      name, // Store name visible in Redux DevTools
      enabled: import.meta.env.DEV, // Only enable in development
    }),
  );
};
